export default "//cloud.imgsmail.ru/cloud.mail.ru/123509/img/build/errors/error-500.png";